import { render, staticRenderFns } from "./StyledText.vue?vue&type=template&id=e5645d46&scoped=true&"
import script from "./StyledText.vue?vue&type=script&lang=ts&"
export * from "./StyledText.vue?vue&type=script&lang=ts&"
import style0 from "./StyledText.vue?vue&type=style&index=0&id=e5645d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5645d46",
  null
  
)

export default component.exports